import { ILeaderboard } from '../Models/LeaderboardModels';
export class LeaderboardService {
  constructor(private leaderboardUrl: string) {}

  public getLeaderboard = async (): Promise<ILeaderboard> => {
    const result = await fetch(this.leaderboardUrl);
    return await result.json();
  };
}
